const hasNumber = new RegExp('^-?[0-9]+$')

export async function categories({ id = 0, filter = '', postType }) {
  const selectedCategory = document.querySelector('#categoryShow')
    ? document.querySelector('#categoryShow').value
    : false

  const myId = id
  if (selectedCategory && myId !== 0 && typeof myId === 'string') {
    const idsArray = myId.split(',')
    if (!idsArray.includes(selectedCategory)) {
      id = myId.concat(','.concat(selectedCategory))
    }
  } else if (myId === 0 && selectedCategory) {
    id = '0, '.concat(selectedCategory)
  }

  if (id || id === 0) {
    filter += `&include=${id}`
  }

  let url = ''
  if (postType === 'posts') {
    url = clubeCommon.restApiUrl + `/categories?per_page=100${filter}`
  } else if (postType === 'palpite' || postType === 'palpites') {
    url = clubeCommon.restApiUrl + `/prognostic_category?per_page=100${filter}`
  } else if (postType === 'author') {
    url = clubeCommon.restApiUrl + `/users?per_page=100${filter}`
  }

  const data = await fetch(url).then(response => {
    if (response.status === (400 || 404)) {
      return []
    }

    return response.json()
  })

  return data
}

export async function postsByCategory({
  filterDate = 'all',
  id,
  pageCurrent,
  perPage = 12,
  offset = '',
  categoryId = '',
  author = '',
  postType = 'posts',
  search = '',
  subType = '',
  fields = false
}) {
  let customFields = !fields
    ? ['author_name', 'excerpt_post', 'featured_media_post', 'id', 'link', 'title', 'url']
    : fields

  if (hasNumber.test(id) && Number(id) !== 0) {
    categoryId = `=${id}`
  } else {
    /* get lists of categories selected */
    const categoriesList = document.querySelector('#listSelectionPostBlock')
      ? document.querySelector('#listSelectionPostBlock')
      : document.querySelector('#listSelectionPrognosticBlock')

    if (categoriesList) {
      categoryId = `=${categoriesList.value}`
    }
  }

  if (offset < 0) {
    offset = 0
  }

  if (hasNumber.test(offset)) {
    offset = `&offset=${offset}`
  }

  if (!hasNumber.test(pageCurrent)) {
    pageCurrent = 1
  }

  let authorParam = ''
  if (hasNumber.test(author)) {
    authorParam = `&author=${author}`
  } else {
    authorParam = ''
  }

  let categoryName = 'categories'
  let fieldsUrl = ''
  let url = ''

  customFields.forEach(value => {
    fieldsUrl += `&_fields[]=${value}`
  })

  if (postType === 'palpites') {
    categoryName = 'prognostic_category'
  }

  switch (postType) {
    case 'search':
      url =
        clubeCommon.restApiUrl +
        `/search?search=${search}&per_page=${perPage}&page=${pageCurrent}&subtype[]=post&subtype[]=casa-de-apostas&subtype[]=palpites${fieldsUrl}`
      break
    case 'new-search':
      const urlBySubType = ('post' === subType)
                           ? `/search?search=${search}&per_page=${perPage}&page=${pageCurrent}&subtype[]=post&subtype[]=casa-de-apostas${fieldsUrl}`
                           : `/${subType}?filterDate=${filterDate}&search=${search}&per_page=${perPage}&page=${pageCurrent}${fieldsUrl}`

      url = clubeCommon.restApiUrl + urlBySubType

      break
    case 'author':
      const authorId = document.querySelector('#listSelectionPostBlock')
        ? document.querySelector('#listSelectionPostBlock').value
        : author
      const postTypeElement = document.querySelector('.SelectPost-item.active')
      const type = postTypeElement ? postTypeElement.getAttribute('data-id') : '0'

      if (type !== '0') {
        url =
          clubeCommon.restApiUrl +
          `/multiple-post-type?type[]=${type}&autor=${authorId}&per_page=${perPage}&page=${pageCurrent}${fieldsUrl}`
      } else {
        url =
          clubeCommon.restApiUrl +
          `/multiple-post-type?type[]=post&type[]=casa-de-apostas&type[]=palpites&autor=${authorId}&per_page=${perPage}&page=${pageCurrent}${fieldsUrl}`
      }
      break
    default:
      url =
        clubeCommon.restApiUrl +
        `/${postType}?${categoryName}${categoryId}&filterDate=${filterDate}&per_page=${perPage}&page=${pageCurrent}${offset}${authorParam}&_embed${fieldsUrl}`
  }

  const data = await fetch(url).then(response => {
    if (response.status === (400 || 404)) {
      return {
        data: [],
        totalPages: 0,
        pageCurrent: 1,
        categoryId: 0
      }
    }

    return {
      data: response.json(),
      pageCurrent: Number(pageCurrent),
      totalPages: Number(response.headers.get('X-WP-TotalPages')),
      categoryId: Number(id)
    }
  })

  return data
}
